import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import Table from "../../../Utils/Table/Table1";
import ApiService from "../../../Services/user/service";
import { use } from "react";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { AiOutlineDelete } from "react-icons/ai";
import { AiOutlineEye } from "react-icons/ai";
import DocumentModal from "../../../components/documentModal";
import TradingViewChart from "../../../components/tradechart";
import { useLivePrices } from "../../../context/LivePriceContext";
import socket from "../../../Utils/socketClient";
import "./Watchlist.css";
const Watchlist = ({ isSidebar }) => {
  const [tabMode, setTabMode] = useState("FAVORITES");
  const { livePrices } = useLivePrices();
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname === "/user/dashboard" || location.pathname.endsWith("/dashboard");
  const [watchlist, setWatchlist] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [addedSymbols, setAddedSymbols] = useState({});
  const user_id = localStorage.getItem("user_id");
  const currency = localStorage.getItem("currentCurrency");
  const [showModal, setShowModal] = useState(false);
  const [modalList, setModalList] = useState([]);

  const [modalSearch, setModalSearch] = useState("");
  const [activeTab, setActiveTab] = useState("All"); // All | Cash | Commodity | FO | Currency
  const [rows, setRows] = useState([]);
  const [showUsdModal, setShowUsdModal] = useState(false);
  const [usdList, setUsdList] = useState([]);
  const [usdData, setUsdData] = useState([]);
  const [kycStatus, setKycStatus] = useState(0);
  const [showKycModal, setShowKycModal] = useState(false);
  const [showTradeModal, setShowTradeModal] = useState(false);
  const [tradeData, setTradeData] = useState(null);
  const [tradeType, setTradeType] = useState("BUY"); // BUY / SELL
  const [lot, setLot] = useState("");
  const [qty, setQty] = useState("0.00");
  const [orderType, setOrderType] = useState("Market"); // Market | Limit | Stop
  const [productType, setProductType] = useState("Intraday"); // Intraday | Delivery
  const [isMarginTrade, setIsMarginTrade] = useState(false);
  const [usdSearch, setUsdSearch] = useState("");
  const [availableFund, setAvailableFund] = useState(0);
  const [userDetails, setUserDetails] = useState(null);
  const [customPrice, setCustomPrice] = useState("");
  const [watchlistLoading, setWatchlistLoading] = useState(true);
  const [version, setVersion] = useState("");
  // CATEGORY → BACKEND TYPE MAP
  const categoryMap = {
    All: "All",
    Cash: "Cash",
    Commodity: "Commodity",
    FO: "F&O",
    Currency: "Currency"
  };


  const handleTradeClick = (type, item) => {
    //  KYC NOT DONE
    if (kycStatus !== 1) {
      setShowKycModal(true);   //  KYC MODAL OPEN
      return;
    }

    setTradeType(type);
    setTradeData(item);   //  pura API wala item
    setIsMarginTrade(false);
    setShowTradeModal(true);
  };


  const getVersion = async () => {
    const res = await ApiService.getUpdateVersion();
    setVersion(res?.data?.version);

  };

  useEffect(() => {
    getVersion();
  }, []);


  // USER DETAIL
  const getUserData = async () => {
    try {
      const userid = localStorage.getItem("user_id");
      const res = await ApiService.getUserDetail(userid);

      if (res?.data?.data?.length > 0) {
        const user = res.data.data[0];
        setUserDetails(user);
        setKycStatus(user.kyc);
        // 0 = not done, 1 = approved, 2 = pending (example)
        const available = currency === "1" ? Number(user.Inr_Balance || 0) : Number(user.Balance || 0);

        setAvailableFund(available);
      }
    } catch (error) {
      console.log("User detail error", error);
    }
  };
  // FETCH SYMBOL LIST FROM API
  const fetchSymbolList = async () => {
    try {
      const payload = {
        userid: user_id,
        page: 1,
        limit: 50,
        type: categoryMap[activeTab],
        zebu_token: modalSearch || ""
      };

      let res = await ApiService.symbolsmodallist(payload);
      setModalList(res?.data?.data || []);
    } catch (error) {
      console.log("symbol list error:", error);
    }
  };

  useEffect(() => {
    if (tabMode === 'ALL') fetchSymbolList();
  }, [activeTab, modalSearch, tabMode]);

  const fetchWatchlist = async () => {
    const payload = { userid: user_id };

    try {
      setWatchlistLoading(true);
      let res;
      if (currency === "0") {
        res = await ApiService.symbolList(payload);
      } else {
        res = await ApiService.symbolListInr(payload);
      }

      const list = res?.data?.data || [];
      setWatchlist(list);

      //  Auto mark symbols as added (even after refresh)
      const addedMap = list.reduce((acc, item) => {
        acc[item.service_id || item.trading_symbol || item.symbol] = true;
        return acc;
      }, {});

      setAddedSymbols(addedMap);

    } catch (err) {
      console.log("Error fetching watchlist:", err);
    }
    finally {
      setWatchlistLoading(false);
    }
  };


  useEffect(() => {
    getUserData();
    fetchWatchlist();
  }, [currency]);

  useEffect(() => {
    if (showTradeModal) {
      document.body.classList.add('trade-modal-open');
    } else {
      document.body.classList.remove('trade-modal-open');
    }
    return () => document.body.classList.remove('trade-modal-open');
  }, [showTradeModal]);

  // Socket Subscription for INR Market
  useEffect(() => {
    if (currency === "1" && watchlist.length > 0) {
      const subscribeWatchlist = () => {
        const channels = watchlist
          .filter(item => item.exch_seg && item.token)
          .map(item => `${item.exch_seg}|${item.token}`)
          .join("#");
        if (channels) {
          socket.emit("subscribe", channels);
        }
      };

      if (socket.connected) {
        subscribeWatchlist();
      }
      socket.on("connect", subscribeWatchlist);
      return () => {
        socket.off("connect", subscribeWatchlist);
      };
    }
  }, [watchlist, currency]);

  // DELETE FROM WATCHLIST
  const handleDelete = async (serviceId) => {
    let confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    // Run delete only if user confirms
    if (!confirmResult.isConfirmed) return;
    try {
      const payload = {
        userid: user_id,
        symbolid: serviceId
      };

      await ApiService.deleteSymbolInr(payload);
      Swal.fire("Deleted!", "USD Pair deleted successfully", "success");

      fetchWatchlist();
    } catch (err) {
      console.log("Error deleting symbol:", err);
    }
  };



  const handleUsdDelete = async (symbol_name) => {

    let confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    // Run delete only if user confirms
    if (!confirmResult.isConfirmed) return;

    try {
      const payload = {
        userid: user_id,
        symbolname: symbol_name
      };

      await ApiService.deleteSymbolUsd(payload);

      Swal.fire("Deleted!", "USD Pair deleted successfully", "success");

      fetchWatchlist();
    } catch (err) {
      Swal.fire("Error", "Failed to delete USD pair", "error");
    }
  };






  const handleAddStock = async (item) => {
    try {
      const idKey = item._id || item.symbol;

      if (addedSymbols[idKey]) {

        const serviceId = (item.service_id || item._id);

        if (!serviceId) {
          return;
        }

        const payload = {
          userid: user_id,
          symbolid: serviceId
        };

        await ApiService.removeModallist(payload);

        setAddedSymbols(prev => ({
          ...prev,
          [idKey]: false
        }));

        fetchWatchlist();
        return;
      }

      // NOT ADDED → ADD API
      const payload = {
        userid: user_id,
        symbolname: item._id, // backend expects symbol
      };

      await ApiService.addInrSymbol(payload);

      setAddedSymbols(prev => ({
        ...prev,
        [idKey]: true
      }));

      fetchWatchlist();

    } catch (err) {
      console.log("Add/Delete error:", err);
    }
  };

  const updateFavState = (symbol, isFav) => {
    setWatchlist(prev =>
      prev.map(item =>
        item.symbol === symbol ? { ...item, isFav } : item
      )
    );
  };


  const handleFavorite = async (row) => {

    try {
      const payload = {
        userid: user_id,
        symbolname: row.symbol_name,
        exch_seg: row.exch_seg,

      };

      if (row.isFav) {
        // REMOVE FAV
        const res = await ApiService.removeFavoriteInr(payload);
        toast.success("Removed from favourites");

        if (res.status) {
          updateFavState(row.symbol, false);
        }
      } else {
        // ADD FAV
        const res = await ApiService.addFavoriteInr(payload);
        toast.success("Added to favourites");

        if (res.status) {
          updateFavState(row.symbol, true);
        }
      }
    } catch (err) {

    }
  };


  const handleUsdFavorite = async (row) => {


    try {
      const payload = {
        userid: user_id,
        symbolname: row.symbol_name,
        exch_seg: row.exch_seg,
      };

      if (row.isFav) {
        // REMOVE FAV USD
        const res = await ApiService.removeFavoriteUsd(payload);
        toast.success("Removed from favourites");

        if (res.status) {
          updateFavState(row.symbol, false); // UI update
        }
      } else {
        // ADD FAV USD
        const res = await ApiService.addFavoriteUsd(payload);
        toast.success("Added to favourites");

        if (res.status) {
          updateFavState(row.symbol, true); // UI update
        }
      }
    } catch (err) {

    }
  };


  const filteredWatchlist = watchlist.filter((item) =>
    item.symbol?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.symbol_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const fetchUsdList = async () => {
    const payload = { userid: user_id };
    try {
      const res = await ApiService.SearchSymbol(payload);
      setUsdList(res?.data?.data || []);

    } catch (err) {

    }
  };


  const handleUsdAdd = async (item) => {
    try {
      // Already added => do nothing
      if (addedSymbols[item.trading_symbol]) {
        return;
      }

      // Add symbol
      const payload = {
        userid: user_id,
        symbolname: item.trading_symbol
      };

      await ApiService.addSymbol(payload);

      // Mark added
      setAddedSymbols(prev => ({
        ...prev,
        [item.trading_symbol]: true
      }));

      fetchWatchlist();

    } catch (err) {

    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!tradeData) return;

    const livePriceFallback = livePrices[tradeData?.token] || livePrices[tradeData?.symbol?.toLowerCase()] || tradeData?.liveprice;

    const priceToSend =
      orderType === "Market"
        ? Number(livePriceFallback)
        : Number(customPrice || 0);

    const payload = {
      userid: user_id,
      symbol: tradeData.symbol,
      price: priceToSend,
      lot: Number(lot),
      qty: calculatedQty,
      requiredFund: Number(totalAmount),
      type: tradeType,
      lotsize: Number(tradeData.lotsize),
      With_Margin: isMarginTrade,
      selectedOption: orderType,
      limitstopprice:
        orderType === "Market" ? "" : Number(customPrice || 0),
      token: tradeData.symbol,
      margin_type: productType === "Intraday" ? "INTRADAY" : "HOLDING",
      app_version: currency === "1" ? "1.0.0" : version
    };


    try {
      let res;
      if (currency === "0") {
        res = await ApiService.placeOrder(payload);
      } else {
        res = await ApiService.placeOrderInr({
          ...payload,
          symbolid: tradeData.service_id || tradeData._id
        });
      }


      if (res?.data?.status === true) {

        setShowTradeModal(false);
        Swal.fire({
          icon: "success",
          title: "Order Placed",
          text: res?.data?.message,
        })
        navigate("/user/portfolio", {
          state: {
            watchlist: true
          }
        });
        // fetchPositionData();
        // fetchHoldingData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res?.data?.message,
        });
      }
    } catch (err) {
      console.log("Place order error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Something went wrong",
      });
    }
  };



  const livePriceFallbackUI = livePrices[tradeData?.token] || livePrices[tradeData?.symbol?.toLowerCase()] || tradeData?.liveprice;

  const effectivePrice =
    orderType === "Market"
      ? Number(livePriceFallbackUI || 0)
      : Number(customPrice || 0);

  const totalAmount =
    lot && effectivePrice
      ? Number(lot) * Number(tradeData?.lotsize) * effectivePrice
      : "";

  const getLimitDivisor = () => {
    if (!isMarginTrade) return 1;
    if (!userDetails) return 1;

    const limit = Number(userDetails.limit || 1);
    const optionSellingLimit = Number(userDetails.option_selling_limit || 1);

    if (currency === "1") {
      const exchSeg = tradeData?.exch_seg || "";
      if (tradeType === "SELL" && ["NFO", "BFO"].includes(exchSeg)) {
        return limit / optionSellingLimit || 1;
      }
      return limit;
    } else {
      const symbol = tradeData?.symbol || "";
      if (tradeType?.toLowerCase() === "sell" && symbol.length > 10) {
        return limit / optionSellingLimit || 1;
      }
      return limit;
    }
  };

  const limitDivisor = getLimitDivisor();
  const displayedRequiredFunds = totalAmount ? (Number(totalAmount) / limitDivisor).toFixed(2) : "";

  const calculatedQty =
    lot && tradeData
      ? Number(lot) * Number(tradeData.lotsize)
      : 0;


  return (
    <div className="watchlist-container">
      {/* HEADER */}
      <div className="watchlist-header">
        {(!isSidebar) && <h4 className="fw-bold mb-3 d-lg-none" style={{ fontSize: '18px' }}>Quotes</h4>}
        <input
          type="text"
          className="watchlist-search"
          placeholder={currency === "1" ? "Search eg: NIFTY, RELIANCE" : "Search eg: EUR/USD, BTC"}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="watchlist-tabs">
          <div
            className={`watchlist-tab ${tabMode === 'FAVORITES' ? 'active' : ''}`}
            onClick={() => setTabMode('FAVORITES')}
          >
            FAVORITES
          </div>
          <div
            className={`watchlist-tab ${tabMode === 'ALL' ? 'active' : ''}`}
            onClick={() => {
              setTabMode('ALL');
              if (currency !== '1') { fetchUsdList(); }
            }}
          >
            ALL SYMBOLS
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="watchlist-content">
        {watchlistLoading ? (
          <div className="text-center mt-5"><div className="spinner-border text-primary"></div></div>) : tabMode === 'FAVORITES' ? (
            <div className="watchlist-favorites-list" style={{ overflowY: "auto", flex: 1 }}>
              {filteredWatchlist.length === 0 ? (
                <div className="text-center text-muted mt-4">No favorites added</div>
              ) : (
                filteredWatchlist.map((item, index) => (
                  <div key={index} className="watchlist-item" onClick={() => navigate(`/user/dashboard?symbol=${item.symbol || item.trading_symbol}&token=${item.token || ''}`)}>
                    <div className="watchlist-item-left">
                      <span className="watchlist-symbol">{item.symbol || item.trading_symbol}</span>
                      <div style={{ fontSize: "10px", color: "#888", marginTop: "2px", marginBottom: "2px", lineHeight: "1.2" }}>
                        {item.trading_symbol || item.tradesymbol || item.symbol_name || ""}
                        {item.exch_seg && <span style={{ color: '#28a745', marginLeft: '4px' }}>({item.exch_seg})</span>}
                        {/* Fallback for F&O if they are separate properties */}
                        {(!item.symbol_name && !item.tradesymbol && !item.trading_symbol) && (
                          <>{item.expiry && ` • ${item.expiry}`}{item.strike && ` • ${item.strike}`}{item.option_type && ` • ${item.option_type}`}</>
                        )}
                      </div>
                      {/* <span className={`watchlist-sub ${parseFloat(item.change) >= 0 ? 'green' : 'red'}`}>
                        {item.change || '0.00%'} <span style={{ color: '#888', marginLeft: '4px' }}>vol: {item.volume || 109}</span>
                      </span> */}
                    </div>

                    {/* Default Prices */}
                    <div className="watchlist-item-right watchlist-price-right-default">
                      <div className="watchlist-price-row">
                        <span className="watchlist-price-blue">{livePrices[item.token] || item.liveprice || '0.00'}</span>
                        {/* <span className="watchlist-price-red">{livePrices[item.token] || item.liveprice || '0.00'}</span> */}
                      </div>
                      {/* <div className="watchlist-price-hl">
                        L: {item.low || '0.00'} H: {item.high || '0.00'}
                      </div> */}
                    </div>

                    {/* Hover Actions */}
                    <div className="watchlist-actions">
                      <button className="wl-btn delete" onClick={(e) => { e.stopPropagation(); currency === '1' ? handleDelete(item.service_id) : handleUsdDelete(item.symbol_name); }}><i className="fa-solid fa-trash"></i></button>
                      <button className="wl-btn buy" onClick={(e) => { e.stopPropagation(); handleTradeClick('BUY', item); }}>B</button>
                      <button className="wl-btn sell" onClick={(e) => { e.stopPropagation(); handleTradeClick('SELL', item); }}>S</button>
                      <button className="wl-btn chart" onClick={(e) => { e.stopPropagation(); navigate("/user/option-chain", { state: { symbol: item.symbol } }); }}><i className="fa-solid fa-chart-line"></i></button>
                    </div>
                  </div>
                ))
              )}
            </div>
          ) : (
          <div className="watchlist-inline-search d-flex flex-column" style={{ height: "100%" }}>
            {currency === "1" ? (
              <>
                <div className="watchlist-categories mb-2 d-flex flex-wrap gap-1 p-2 border-bottom">
                  {["All", "Cash", "FO", "Commodity", "Currency"].map((cat) => (
                    <button
                      key={cat}
                      className={`btn btn-sm ${activeTab === cat ? "btn-primary" : "btn-outline-secondary"}`}
                      onClick={() => setActiveTab(cat)}
                      style={{ fontSize: "11px", padding: "2px 6px" }}
                    >
                      {cat === "FO" ? "F&O" : cat}
                    </button>
                  ))}
                </div>
                <div className="p-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search symbol..."
                    value={modalSearch}
                    onChange={(e) => setModalSearch(e.target.value)}
                  />
                </div>
                <div className="watchlist-inline-list p-2" style={{ overflowY: "auto", flex: 1 }}>
                  {modalList.length === 0 ? (
                    <p className="text-center text-muted py-4">No stocks found</p>
                  ) : (
                    modalList.map((item, index) => (
                      <div key={index} className="d-flex justify-content-between align-items-center border-bottom py-2">
                        <div>
                          <div className="fw-bold" style={{ fontSize: "13px" }}>{item.symbol}</div>
                          <div className="text-muted" style={{ fontSize: "11px" }}>
                            {item.trading_symbol || item.tradesymbol || item.symbol_name || ""}
                            {item.exch_seg && <span style={{ color: '#28a745', marginLeft: '4px' }}>({item.exch_seg})</span>}
                            {/* Fallback for F&O if they are separate properties */}
                            {(!item.symbol_name && !item.tradesymbol && !item.trading_symbol) && (
                              <>{item.expiry && ` • ${item.expiry}`}{item.strike && ` • ${item.strike}`}{item.option_type && ` • ${item.option_type}`}</>
                            )}
                          </div>
                        </div>
                        <button
                          className={`btn btn-sm ${addedSymbols[item._id || item.symbol] ? "btn-success text-white" : "btn-danger text-white"}`}
                          onClick={() => handleAddStock(item)}
                          style={{ fontSize: "11px", padding: "4px 8px" }}
                        >
                          {addedSymbols[item._id || item.symbol] ? "Added ✓" : "+ Add"}
                        </button>
                      </div>
                    ))
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="p-2 border-bottom">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search trading symbol..."
                    value={usdSearch}
                    onChange={(e) => setUsdSearch(e.target.value)}
                  />
                </div>
                <div className="watchlist-inline-list p-2" style={{ overflowY: "auto", flex: 1 }}>
                  {usdList
                    .filter(item => item.trading_symbol.toLowerCase().includes(usdSearch.toLowerCase()))
                    .map((item, index) => (
                      <div key={index} className="d-flex justify-content-between align-items-center border-bottom py-2">
                        <div>
                          <div className="fw-bold" style={{ fontSize: "13px" }}>{item.trading_symbol}</div>
                          <div className="text-muted" style={{ fontSize: "11px" }}>{item.exch_seg} • Lot: {item.lotsize}</div>
                        </div>
                        <button
                          className={`btn btn-sm ${addedSymbols[item.trading_symbol] ? "btn-success" : "btn-primary"}`}
                          disabled={addedSymbols[item.trading_symbol]}
                          onClick={() => handleUsdAdd(item)}
                          style={{ fontSize: "11px", padding: "4px 8px" }}
                        >
                          {addedSymbols[item.trading_symbol] ? "Added ✓" : "+ Add"}
                        </button>
                      </div>
                    ))
                  }
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* MODAL */}
      {showKycModal && (
        <DocumentModal
          show={showKycModal}
          onClose={() => {
            setShowKycModal(false);
            getUserData();
          }}
        />
      )}

      {showTradeModal && tradeData && createPortal(
        <form 
          onSubmit={handleSubmit} 
          className="trade-panel-inline shadow-sm" 
        >
          <div className="p-3" style={{ overflowY: "auto", flex: 1 }}>

                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="m-0 text-uppercase text-info">
                    {tradeData.exch_seg}
                  </h6>
                  <button
                    type="button"
                    className="btn btn-sm btn-danger px-3 py-1 fw-bold text-white shadow-sm"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowTradeModal(false);
                    }}
                    style={{ zIndex: 9999, position: "relative", pointerEvents: "auto", borderRadius: "8px" }}
                  >
                    X
                  </button>
                </div>


                {/* <TradingViewChart /> */}
                {!isDashboard && (
                  <TradingViewChart
                    symbol={tradeData?.symbol}
                    price={tradeData?.liveprice}
                  />
                )}
                {/* SYMBOL + PRICE */}
                <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
                  <h5 className="fw-bold m-0">{tradeData.symbol}</h5>
                  <h5 className="fw-bold text-info m-0">
                    {currency === "1" ? "₹" : "$"}{tradeData.liveprice}
                  </h5>
                </div>

                {/* LOT SIZE + LOT */}
                <div className="row g-2">
                  <div className="col-6">
                    <label className="small text-secondary">Lot Size</label>
                    <input
                      className="form-control border-0 text-dark"
                      style={{ background: "#f3f4f6" }}
                      value={tradeData.lotsize}
                      disabled
                    />
                  </div>

                  <div className="col-6">
                    <label className="small text-secondary">Lot</label>
                    <input
                      className="form-control text-dark"
                      style={{ background: "#f3f4f6", border: "1px solid #e5e7eb" }}
                      placeholder="Enter Lot"
                      value={lot}
                      onChange={(e) => {
                        const val = e.target.value;
                        setLot(val);
                        setQty(val ? Number(val).toFixed(1) : "0.00");
                      }}
                    />
                  </div>
                </div>

                {/* QTY */}
                <div className="mt-3">
                  <label className="small text-secondary">Buy / Sell Quantity</label>
                  <input
                    className="form-control text-dark border-0"
                    style={{ background: "#f3f4f6" }}
                    value={qty}
                    disabled
                  />
                </div>

                {/* ORDER TYPE */}
                <div className="d-flex gap-2 mt-3">
                  {["Market", "Limit", "Stop"].map((t) => (
                    <button
                      type="button"
                      key={t}
                      className="btn w-100"
                      onClick={() => setOrderType(t)}
                      style={{
                        background: orderType === t ? "#2563eb" : "#f3f4f6",
                        border: "1px solid #e5e7eb",
                        color: orderType === t ? "#fff" : "#000",
                        borderRadius: "20px",
                      }}
                    >
                      {t}
                    </button>
                  ))}
                </div>

                {(orderType === "Limit" || orderType === "Stop") && (
                  <div className="mt-3">
                    <label className="small text-secondary">
                      {orderType === "Limit" ? "Limit Price" : "Trigger Price"}
                    </label>

                    <input
                      className="form-control text-dark border-0"
                      style={{ background: "#f3f4f6" }}
                      placeholder="Enter Price"
                      value={customPrice}
                      onChange={(e) => setCustomPrice(e.target.value)}
                    />
                  </div>
                )}

                {/* PRODUCT TYPE */}
                <div className="d-flex gap-2 mt-3">
                  {["Intraday", "Delivery"].map((p) => (
                    <button
                      type="button"
                      key={p}
                      className="btn w-100"
                      onClick={() => setProductType(p)}
                      style={{
                        background: productType === p ? "#2563eb" : "#f3f4f6",
                        border: "1px solid #e5e7eb",
                        color: productType === p ? "#fff" : "#000",
                        borderRadius: "20px",
                      }}
                    >
                      {p}
                    </button>
                  ))}
                </div>

                {/* MARGIN CHECKBOX */}
                <div className="mt-2 form-check d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="marginCheck"
                    checked={isMarginTrade}
                    onChange={(e) => setIsMarginTrade(e.target.checked)}
                    style={{ cursor: "pointer", marginRight: "8px", marginTop: "0" }}
                  />
                  <label className="form-check-label small text-secondary" htmlFor="marginCheck" style={{ cursor: "pointer" }}>
                    Trade with margin (Otherwise actual funds will be deducted)
                  </label>
                </div>

                {/* PRICE + BROKERAGE */}
                <div className="row g-2 mt-3">
                  <div className="col-6">
                    <div className="p-2 rounded" style={{ background: "#f3f4f6" }}>
                      <div className="small text-secondary">Price</div>
                      <input
                        style={{ background: "transparent", border: "none", color: "#000", width: "100%" }}
                        value={totalAmount}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="p-2 rounded" style={{ background: "#f3f4f6" }}>
                      <div className="small text-secondary">Brokerage</div>
                      <div className="text-dark">
                        {currency === "0" ? "$" : "₹"}{lot ? `${Number(lot).toFixed(1)} + ${Number(lot).toFixed(1)}` : "0.0 + 0.0"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* FUNDS */}
                <div className="row g-2 mt-3">
                  <div className="col-6">
                    <div className="p-3 rounded" style={{ background: "#f3f4f6" }}>
                      <div className="text-dark small fw-bold">Required Funds</div>
                      <input
                        style={{ background: "transparent", border: "none", color: "#000", width: "100%", fontWeight: "bold" }}
                        value={displayedRequiredFunds ? (currency === "0" ? "$" : "₹") + displayedRequiredFunds : ""}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="p-3 rounded" style={{ background: "#f3f4f6" }}>
                      <div className="text-dark small fw-bold">Available Margin</div>
                      <div className="fw-bold text-dark">
                        {currency === "0" ? "$" : "₹"}{availableFund.toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* BUY / SELL */}
                <button
                  className="btn w-100 mt-4 fw-bold py-2"
                  style={{
                    background: tradeType === "BUY" ? "#16a34a" : "#dc2626",
                    color: "#fff",
                    fontSize: "18px",
                    borderRadius: "12px",
                  }}


                >
                  {tradeType}
                </button>

          </div>
        </form>,
        document.getElementById('right-sidebar-container') || document.body
      )}


    </div>
  );
};

export default Watchlist;
